import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import Collapse from '@material-ui/core/Collapse';
import CircularProgress from '@material-ui/core/CircularProgress';
import Alert from '@material-ui/lab/Alert';
import Grid from '@material-ui/core/Grid';
import ListOfUsers from '../../components/ListOfUsers';
import HeadTable from '../../components/HeadTable';
import moment from 'moment';
import 'moment/locale/pt-br';
import DateFnsUtils from '@date-io/date-fns';
import ptBrLocale from 'date-fns/locale/pt-BR';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import { instanceAxios } from '../../InstanceAxios';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import IconButton from '@material-ui/core/IconButton';
import FilterIcon from '@material-ui/icons/FilterList';

function DescontoIndicacao() {
  const useStyles = makeStyles((theme) => ({
    root: {
      height: '',
      overflow: 'auto',
      width: '95%',
    },
    paper: {
      position: 'absolute',
      width: 800,
      backgroundColor: theme.palette.background.paper,
      border: '2px solid #000',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
      top: `50%`,
      left: `50%`,
      transform: `translate(-50%, -50%)`,
      width: '80%',
      height: '80%',
      overflow: 'auto',
    },
    loading: {
      marginLeft: '50%',
    },
  }));

  const [columns, setColumns] = useState([
    {
      id: `"Indicador"."nome"`,
      label: 'Indicador',
      minWidth: 150,
      filterable: true,
    },
    {
      id: `"Indicado"."nome"`,
      label: 'Indicado',
      minWidth: 150,
      filterable: true,
    },
    { id: 'created_at', label: 'Data de Uso', minWidth: 50, filterable: true },
    {
      id: 'mes_desconto',
      label: 'Mês do Desconto',
      minWidth: 50,
      filterable: true,
    },
  ]);
  const [openAlert, setOpenAlert] = useState(false);
  const [tipoAlert, setTipoAlert] = useState('');
  const [messageAlert, setMessageAlert] = useState('');
  const [ready, setReady] = useState(true);
  const [nomeUsuario, setNomeUsuario] = useState('');
  const [usuario, setUsuario] = useState(null);
  const [dtInicial, setDtInicial] = useState(
    moment('2020-01-01').format('YYYY-MM-DD HH:ss')
  );
  const [dtFinal, setDtFinal] = useState(moment().format('YYYY-MM-DD HH:ss'));

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalPosition, setModalPosition] = useState({ top: 0, left: 0 });
  const [filterText, setFilterText] = useState('');
  const [columnId, setColumnId] = useState('');
  const [idOrder, setIdOrder] = useState('');
  const [order, setOrder] = useState('asc');
  const [originalDescontos, setOriginalDescontos] = useState([]);

  const [descontos, setDescontos] = useState([]);
  const [count, setCount] = useState(0);
  const [qtdPorPagina, setQtdPorPagina] = useState(10);
  const [page, setPage] = useState(0);

  useEffect(() => {
    atualizarDescontos('', '', '', '', '', '', '');
  }, []);

  const clickAlert = () => {
    setOpenAlert(false);
    setTipoAlert('');
    setMessageAlert('');
  };

  const handleChangeUsuario = async (user) => {
    setUsuario(user);
    atualizarDescontos(
      user.id,
      dtInicial,
      dtFinal,
      page,
      qtdPorPagina,
      idOrder,
      order
    );
  };

  const handleDataIncial = async (data) => {
    const idUsuario = usuario ? usuario.id : '';
    setDtInicial(data);
    atualizarDescontos(
      idUsuario,
      data,
      dtFinal,
      page,
      qtdPorPagina,
      idOrder,
      order
    );
  };

  const handleDataFinal = async (data) => {
    const idUsuario = usuario ? usuario.id : '';
    setDtFinal(data);
    atualizarDescontos(
      idUsuario,
      dtInicial,
      data,
      page,
      qtdPorPagina,
      idOrder,
      order
    );
  };

  const handleChangePage = (event, newPage) => {
    const idUsuario = usuario ? usuario.id : '';
    setPage(newPage);
    atualizarDescontos(
      idUsuario,
      dtInicial,
      dtFinal,
      newPage,
      qtdPorPagina,
      idOrder,
      order
    );
  };

  const handleChangeRowsPerPage = (event) => {
    const idUsuario = usuario ? usuario.id : '';
    setQtdPorPagina(event.target.value);
    atualizarDescontos(
      idUsuario,
      dtInicial,
      dtFinal,
      page,
      event.target.value,
      idOrder,
      order
    );
  };

  const setIdOrderUpdate = (id) => {
    const idUsuario = usuario ? usuario.id : '';
    let o;
    // Checando se é o mesmo atual
    if (id === idOrder) {
      o = order === 'asc' ? 'desc' : 'asc';
      setOrder(o);
    } else {
      o = 'asc';
      setIdOrder(id);
    }
    atualizarDescontos(
      idUsuario,
      dtInicial,
      dtFinal,
      page,
      qtdPorPagina,
      id,
      o
    );
  };

  const atualizarDescontos = async (id, dtIni, dtFnl, pg, qpg, io, o) => {
    setReady(false);
    await instanceAxios(localStorage.getItem('toobiauth'))
      .get(
        `/listaIndicacoes?idUsuario=${id}&dtInicial=${dtIni}&dtFinal=${dtFnl}&limit=${qpg}&page=${pg}&&campoOrdenacao=${io}&ordem=${o}`
      )
      .then((res) => {
        const rows = Array.isArray(res?.data?.rows) ? res.data.rows : [];

        setCount(res?.data?.count || 0);
        setDescontos(rows);
        setOriginalDescontos(rows);
        setReady(true);
      })
      .catch((err) => {
        console.log(err);
        setReady(true);
        setOpenAlert(true);
        setTipoAlert('error');
        setMessageAlert('Sem conexão com Internet!');
      });
  };

  const openModalFilter = (event, columnid) => {
    setFilterText('');
    const rect = event.target.getBoundingClientRect();
    setIsModalOpen(true);
    setModalPosition({ top: rect.top, left: rect.left });
    setColumnId(columnid);
  };

  const handleFilterTextChange = (event) => {
    setFilterText(event.target.value);
  };

  // Function to filter the table data
  const filterTable = () => {
    setIsModalOpen(false);

    const filteredDas = originalDescontos.filter((item) => {
      const value = getValueColumnId(columnId, item);
      return (
        value &&
        value.toString().toLowerCase().includes(filterText.toLowerCase())
      );
    });
    // Update the table data with filtered data
    setDescontos(filteredDas);
  };

  const getValueColumnId = (columnIdAux, rowData) => {
    columnIdAux = columnIdAux.replace(/"/g, '');

    const parts = columnIdAux.split('.');

    let result = null;
    for (let part of parts) {
      if (result === null) {
        // If result is null, assign the global object to result
        result = rowData[part];
      } else {
        // If result is not null, access the property
        result = result[part];
      }
    }
    return result;
  };

  const clearFilter = () => {
    setIsModalOpen(false);
    setFilterText('');
    setDescontos(originalDescontos);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleRequestSort = (property) => {
    const orderBy = property;

    if (idOrder === property && order === 'desc') {
      setOrder('asc');
    } else {
      setOrder('desc');
    }

    setIdOrder(orderBy);
  };

  const sortTable = (property) => {
    const isAsc = order === 'asc';
    const descontosOrdenados = Array.isArray(descontos) ? [...descontos] : [];

    descontosOrdenados.sort((a, b) => {
      let aValue = getValueColumnId(property, a);
      let bValue = getValueColumnId(property, b);
      // If the property is a string, convert to lowercase for case-insensitive sorting
      if (typeof aValue === 'string') {
        aValue = aValue.toLowerCase();
        bValue = bValue.toLowerCase();
      }
      if (aValue < bValue) {
        return isAsc ? -1 : 1;
      }
      if (aValue > bValue) {
        return isAsc ? 1 : -1;
      }
      return 0;
    });
    setDescontos(descontosOrdenados);
  };

  const classes = useStyles();
  return (
    <>
      <Modal
        open={isModalOpen}
        onClose={closeModal}
        style={{ top: modalPosition.top, left: modalPosition.left }}
      >
        <div
          style={{
            backgroundColor: 'white',
            padding: '20px',
            borderRadius: '5px',
            width: '300px',
          }}
        >
          <TextField
            label="Filtrar"
            variant="outlined"
            value={filterText}
            onChange={handleFilterTextChange}
            fullWidth
          />
          <Button
            variant="contained"
            color="primary"
            onClick={filterTable}
            style={{ marginTop: '10px' }}
          >
            Filtrar
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={clearFilter}
            style={{ marginTop: '10px', marginLeft: '5px', width: 70 }}
          >
            Limpar
          </Button>
        </div>
      </Modal>
      <div align="center">
        <h1>Códigos Desconto</h1>
      </div>
      <Collapse in={openAlert}>
        <Alert severity={tipoAlert} onClick={clickAlert}>
          {messageAlert}
        </Alert>
      </Collapse>
      <Paper className={classes.root}>
        <Collapse in={ready === false}>
          <CircularProgress className={classes.loading} />
        </Collapse>
        <Collapse in={ready}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              padding: 10,
            }}
          >
            <Grid container>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <ListOfUsers
                  label="Nome do Cliente *"
                  width="40%"
                  userSelect={nomeUsuario}
                  setUserSelect={(user) => setNomeUsuario(user)}
                  setObjUser={(user) => handleChangeUsuario(user)}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <div align="right">
                  <MuiPickersUtilsProvider
                    utils={DateFnsUtils}
                    locale={ptBrLocale}
                  >
                    <Grid container justify="space-around">
                      <KeyboardDatePicker
                        margin="normal"
                        id="picker-inicio"
                        label="Data Inicial"
                        format="dd/MM/yyyy"
                        value={dtInicial}
                        onChange={handleDataIncial}
                        KeyboardButtonProps={{
                          'aria-label': 'Mudar Data Inicial',
                        }}
                      />
                      <KeyboardDatePicker
                        margin="normal"
                        id="picker-final"
                        label="Data Final"
                        format="dd/MM/yyyy"
                        value={dtFinal}
                        onChange={handleDataFinal}
                        KeyboardButtonProps={{
                          'aria-label': 'Mudar Data Final',
                        }}
                      />
                    </Grid>
                  </MuiPickersUtilsProvider>
                </div>
              </Grid>
            </Grid>
          </div>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <TableSortLabel
                        active={idOrder === column.id}
                        direction={idOrder === column.id ? order : 'asc'}
                        onClick={() => {
                          handleRequestSort(column.id);
                          setTimeout(() => {
                            sortTable(column.id);
                          }, 200);
                        }}
                      >
                        {column.label}
                      </TableSortLabel>

                      {column.filterable && (
                        <IconButton
                          style={{ marginLeft: -5 }}
                          onClick={(event) => openModalFilter(event, column.id)}
                          aria-label="filtra"
                        >
                          <FilterIcon style={{ width: 16, height: 16 }} />
                        </IconButton>
                      )}
                    </div>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {(Array.isArray(descontos) ? descontos : []).map((d) => {
                return (
                  <TableRow>
                    <TableCell component="th" scope="row">
                      {d.Indicador.nome}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {d.Indicado.nome}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {moment(d.createdAt).format('L')}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {`${d.mes_desconto}/${d.ano_desconto}`}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          <TableFooter>
            <TableRow>
              <TablePagination
                component="div"
                style={{ backgroundColor: '#FFF' }}
                rowsPerPageOptions={[5, 10, 25]}
                count={count}
                rowsPerPage={qtdPorPagina}
                page={page}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                labelRowsPerPage="Linhas por página"
              />
            </TableRow>
          </TableFooter>
        </Collapse>
      </Paper>
    </>
  );
}

export default DescontoIndicacao;
